import axios from "axios";

// api
import api from "api/api";

const isLoggedIn = async () => {
	try {
		const { data } = await axios.get(`${api}/auth/login`);
		return +data === 1;
	} catch (e) {
		console.error(e);
		return false;
	}
};

export default isLoggedIn;
